class AdminImport {
    id: number;
    type: string;
    school: string;
    fileName: string;
    status: number;
    publishStatus: number;
    statusMessage: string;
    lastActivity: Date;

    constructor(data: Partial<AdminImport>) {
        Object.assign(this, data);

        if (typeof this.lastActivity === "string")
            this.lastActivity = new Date(this.lastActivity);
    }
}

export default AdminImport;